import React from "react";
import {
  Paper,
  Button,
  TextField,
  IconButton,
  DialogTitle,
  DialogContent,
  DialogActions,
  Tooltip,
  Divider,
  Checkbox,
  Stack,
} from "@mui/material";
import { Add, Delete, Edit } from "@mui/icons-material";
import SearchIcon from "@mui/icons-material/Search";
import { DataGrid } from "@mui/x-data-grid";
import { ptBR } from "@mui/x-data-grid/locales";
import { D, SearchField, CustomSelect, ConfirmDialog } from "../include";
import _ from "underscore";

function UserForm(props) {
  const [displayName, setDisplayName] = React.useState(props.row ? props.row.name : "");
  const [email, setEmail] = React.useState(props.row ? props.row.email : "");
  const [accessProfile, setAccessProfile] = React.useState(props.row ? props.row.role : "");
  const [company, setCompany] = React.useState(props.row ? props.row.company : "");
  const [password, setPassword] = React.useState("");
  const [passwordConfirm, setPasswordConfirm] = React.useState("");
  const [accessProfileSelector, setAccessProfileSelector] = React.useState([]);
  const [companySelector, setCompanySelector] = React.useState([]);
  const [profilesData, setProfilesData] = React.useState([]);
  const [companyData, setCompanyData] = React.useState([]);

  React.useEffect(() => {
    props.api.get("/UserProfiles").then((r) => {
      setProfilesData(r.profiles);
      setAccessProfileSelector(r.profiles.map((z) => z.name));
    });
    props.api.get("/Companies").then((r) => {
      setCompanyData(r.companies);
      setCompanySelector(r.companies.map((z) => z.name));
    });
  }, [props.api]);

  const handleSubmit = (event) => {
    event.preventDefault();

    const dt = {
      displayName: displayName,
      email: email,
      accessProfile: {
        label: accessProfile,
        value: _.where(profilesData, { name: accessProfile })[0].id,
      },
      company: {
        label: company,
        value: _.where(companyData, { name: company })[0].id,
      },
    };

    if (password) {
      dt.password = password;
      dt["password-confirm"] = passwordConfirm;
    }

    if (!props.edit) {
      props.api
        .post("/Users/", dt)
        .then((r) => {
          props.dialogClose();
          props.alert("Usuário criado com sucesso");
        })
        .catch(() => props.alert("Ocorreu um erro ao criar o usuário"));
    } else {
      props.api
        .put("/User/", dt)
        .then((r) => {
          props.dialogClose();
          props.alert("Alterações salvas com sucesso");
        })
        .catch(() => props.alert("Ocorreu um erro ao salvar as alterações"));
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      {!props.edit ? (
        <DialogTitle style={{ minWidth: "400px" }}>Novo usuário</DialogTitle>
      ) : (
        <DialogTitle style={{ minWidth: "400px" }}>Editar usuário</DialogTitle>
      )}
      <DialogContent>
        <TextField
          required
          type="text"
          value={displayName}
          onChange={(e) => setDisplayName(e.target.value)}
          name="displayName"
          label="Nome"
          fullWidth
          margin="normal"
          variant="outlined"
        />
        <TextField
          required
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          name="email"
          label="E-mail"
          fullWidth
          margin="normal"
          variant="outlined"
          disabled={!!props.edit}
        />
        <TextField
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          name="password"
          label="Nova senha"
          fullWidth
          margin="normal"
          variant="outlined"
          autoComplete="off"
        />
        <TextField
          type="password"
          value={passwordConfirm}
          onChange={(e) => setPasswordConfirm(e.target.value)}
          name="passwordConfirm"
          label="Confirmar senha"
          fullWidth
          margin="normal"
          variant="outlined"
          error={password !== passwordConfirm}
          helperText={password !== passwordConfirm && "Senhas diferentes"}
          autoComplete="off"
        />
        <D size="0.1rem" />
        <Stack spacing={2}>
          <CustomSelect
            id="select-profile"
            label="Perfil de acesso"
            options={accessProfileSelector}
            value={accessProfile}
            onChange={(e) => setAccessProfile(e)}
          />
          <CustomSelect
            id="select-company"
            label="Empresa"
            options={companySelector}
            value={company}
            onChange={(e) => setCompany(e)}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="primary" onClick={props.dialogClose}>
          Cancelar
        </Button>
        <Button variant="outlined" color="primary" type="submit">
          Salvar
        </Button>
      </DialogActions>
    </form>
  );
}

export class Users extends React.Component {
  constructor(props) {
    super(props);
    this.updateData = this.updateData.bind(this);
    this.state = {
      searchField: "",
      dataTable: [],
      loading: true,
      page: 0,
      pageSize: 25,
      totalRows: 0,
      selectedRows: [],
    };

    this.columns = [
      ...(this.props.permission === "w"
        ? [
            {
              field: "check",
              headerName: "Seleção",
              width: 100,
              sortable: false,
              renderCell: (params) => (
                <Checkbox checked={this.state.selectedRows.includes(params.row) } onChange={() => this.onRowClick(params.row)} />
              ),
            },
          ]
        : []),
      { field: "id", headerName: "ID", width: 70 },
      { field: "name", headerName: "Nome", flex: 1 },
      { field: "email", headerName: "E-mail", flex: 1 },
      { field: "role", headerName: "Perfil de acesso", width: 150 },
      { field: "company", headerName: "Empresa", flex: 1 },
    ];
  }

  componentDidMount() {
    this.updateData();
  }

  updateData(page = this.state.page, pageSize = this.state.pageSize, searchField = this.state.searchField) {
    this.setState({ loading: true });
    this.props.api
      .get("/Users", { params: { page, pageSize, search: searchField } })
      .then((r) => {
        this.setState({
          dataTable: r.users || [],
          totalRows: Number(r.total) || 0,
          loading: false,
        });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  }

  handleSearch = () => {
    this.setState({ page: 0 }, () => {
      this.updateData(0, this.state.pageSize, this.state.searchField);
    });
  };

  handlePaginationModelChange = (newpagemodel, reason) => {
    var pageSizeChanged = (newpagemodel.pageSize === this.state.pageSize) ? false : true
        
    this.setState({ page: newpagemodel.page, pageSize: newpagemodel.pageSize }, () => {
      this.updateData(pageSizeChanged ? 0 : newpagemodel.page, newpagemodel.pageSize);
    });
  };

  onRowClick = (i) => {
    this.setState({
      selectedRows: this.state.selectedRows.indexOf(i.id) > -1 ? _.without(this.state.selectedRows, i.id) : _.union(this.state.selectedRows, [i.id]),
    });
  };

  findRow = (id) => {
    return this.state.dataTable.find((row) => row.id === id);
  };

  render() {
    const { searchField, dataTable, loading, page, pageSize, totalRows } = this.state;

    return (
      <D className="col e aF scD" style={{ padding: '2rem' }}>
        <D className="row w aF">
          <SearchField
            value={searchField}
            onChange={(v) => this.setState({ searchField: v })}
        />
        <Tooltip title="Pesquisar" arrow>
          <IconButton sx={{ marginLeft: '12px' }} onClick={this.handleSearch}>
            <SearchIcon />
          </IconButton>
        </Tooltip>
              
        {this.props.permission === 'w' && (
          <> 
              <Divider sx={{ paddingRight: "5px" }} orientation="vertical" flexItem />
              <D size="0.5rem" />

              {this.state.selectedRows.length === 1 && (
                <>
                  <Tooltip title="Editar item" arrow>
                    <IconButton
                      onClick={() =>
                        this.props.dialog(
                          <UserForm
                            edit
                            row={this.findRow(this.state.selectedRows[0])}
                            api={this.props.api}
                            alert={this.props.alert}
                            dialogClose={() => {
                              this.props.dialogClose();
                              this.setState({ selectedRows: [] });
                              this.updateData();
                            }}
                          />
                        )
                      }
                    >
                      <Edit />
                    </IconButton>
                  </Tooltip>
                  <D size="0.5rem" />
                </>
              )}

              {this.state.selectedRows.length > 0 && (
                <>
                  <Tooltip title="Excluir selecionados" arrow>
                    <IconButton
                      onClick={() =>
                        this.props.dialog(
                          <ConfirmDialog
                            title="Excluir Itens"
                            msg="Ao confirmar, os itens serão excluídos e não poderão ser recuperados"
                            reg={
                              this.state.selectedRows.length > 1
                                ? this.state.selectedRows.length + " registros selecionados"
                                : "1 registro selecionado"
                            }
                            onCancel={this.props.dialogClose}
                            onConfirm={() => {
                              for (let id of this.state.selectedRows) {
                                this.props.api
                                  .delete("/User/" + id)
                                  .then((r) => {
                                    this.props.alert(r.message);
                                    this.props.dialogClose();
                                    this.setState({ selectedRows: [] });
                                    this.updateData();
                                  })
                                  .catch(() => this.props.alert("Ocorreu um erro ao excluir o registro"));
                              }
                            }}
                          />
                        )
                      }
                    >
                      <Delete />
                    </IconButton>
                  </Tooltip>
                  <D size="0.5rem" />
                </>
              )}

              <D e />
              <Tooltip title="Inserir" arrow>
                <IconButton
                  sx={{ marginLeft: "12px" }}
                  onClick={() =>
                    this.props.dialog(
                      <UserForm
                        edit={false}
                        row={null}
                        api={this.props.api}
                        alert={this.props.alert}
                        dialogClose={() => {
                          this.props.dialogClose();
                          this.setState({ selectedRows: [] });
                          this.updateData();
                        }}
                      />
                    )
                  }
                >
                  <Add />
                </IconButton>
              </Tooltip>
          </>
        )}
          </D>
        <D h="1rem" />
        
        <Paper sx={{ width: "100%", height: "800px", overflow: "hidden" }}>
          <DataGrid
            rows={dataTable}
            columns={this.columns}
            pagination
            paginationMode="server"
            rowCount={totalRows}
            loading={loading}            
            pageSizeOptions={[25, 50, 100]}
            paginationModel={{pageSize: pageSize, page: page} }
            onPaginationModelChange={this.handlePaginationModelChange}            
            disableSelectionOnClick
            localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
          />
        </Paper>
      </D>
    );
  }
}
